module.exports = __webpack_public_path__ + "img/npm.1fe43801.svg";